import React from 'react';

import styled from '@emotion/styled';
import { mq, baseDurationTime, green01 } from '../../_style';
import { Link } from 'gatsby';
import icon from '../../assets/imgs/lineup/icon-show-all.png';


export default class ShowAllBtn extends React.Component {
  render() {
    const Container = styled.button`
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1;
      cursor: pointer;
      transition: color ${baseDurationTime} ease;
      ${mq.pc} {
        &:hover {
          color: ${green01};
        }
      }
      ${mq.sp} {
        font-size: 12px;
      }
      &::after {
        content: "";
        display: block;
        width: 13px;
        height: 13px;
        margin-left: 15px;
        background-image: url(${icon});
        background-size: contain;
        ${mq.ie} {
          transform: translateY(-2px);
        }
        ${mq.sp} {
          width: 11px;
          height: 11px;
          margin-left: 11px;
        }
      }
    `;
    const ButtonLink = this.props.to && Container.withComponent(Link);
    const TagName = this.props.to ? ButtonLink : Container;
    return (
      <TagName onClick={this.props.fun ? this.props.fun : null} value={this.props.fun ? 'all' : null} data-categoryname={this.props.fun ? '全て' : null} to={this.props.to ? this.props.to : null}>すべての製品を見る</TagName>
    );
  }
}
